import { AfterContentChecked, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { debounceTime, Subject } from "rxjs";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { EnrollmentAddService } from "src/app/services/enrollment-add.service";
import { EnrollmentBuyupService } from "src/app/services/enrollment-buyup.service";
import { CoverageDependent, CoverageTab } from "src/app/models/coverage";
import { CoverageRate } from "src/app/models/coverage-rate";
import { TableColumn } from "src/app/models/table";
import { TableColumnType } from "src/app/constants/table";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { TableService } from "src/app/services/table.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogDependentComponent } from 'src/app/components/shared/dialog/dependent.component';
import { NextPanel } from 'src/app/models/next-panel';
import { DependentDialogModel } from 'src/app/models/dialog';
import { SvgMatType } from "src/app/constants/icons";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-coverage-calced-tier-selection-grid',
    templateUrl: './calced-tier-selection-grid.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalcedTierSelectionGridComponent implements OnInit, AfterContentChecked {
    @Input() coverageFormGroup: FormGroup;
    @Input() coverageTab: CoverageTab;
    @Input() coverageArrayName: string;
    @Input() showAddDependentButton: boolean;

    @Output() public emitReload: EventEmitter<any> = new EventEmitter();

    private debouncer: Subject<string> = new Subject<string>();
    private coverageDropDownDetailId: number = 0;
    
    public Members: CoverageDependent[] = new Array<CoverageDependent>();
    public columnType = TableColumnType;

    public toggleLabelName: string = 'toggleLabelName';
    public enableFormToggle: string = 'enableFormToggle';
    public renderdColumns: string[] = [];
    public membersData = new MatTableDataSource<CoverageDependent>();
    public membersColumns: TableColumn[] = [
        {
            columnName: 'Add/Term',
            propertyId: 'isSelected',
            columnType: TableColumnType.slideToggle,
            dataTypeText: this.toggleLabelName,
            width: '12%',
        },
        {
            columnName: 'Name',
            propertyId: 'coveredMemberName',
            columnType: TableColumnType.labelAndToolTip,
            svgCustomName: SvgMatType.SmsFailed,
            toolTip: 'disabledMessage',
            toolTipCSS: 'error',
            toolTipDisplayEnd: true,
        },
        {
            columnName: 'Relationship',
            propertyId: 'relationship',
            columnType: TableColumnType.label,
        },
    ];
    

    public selectedMembers: number[] = new Array<number>();
    public displayRates: boolean = true;
    public tierData = new MatTableDataSource<CoverageRate>(); 
    public tierColumns: TableColumn[] = [
		{
			columnName: 'Tier',
			propertyId  : 'tier',
            columnType: TableColumnType.label,
		},
		{
			columnName: 'Employee Deduction',
			propertyId  : 'employeeDeduction',
            columnType: TableColumnType.label,
		},
		{
			columnName: 'Deduction Frequency',
			propertyId  : 'deductionFrequency',
            columnType: TableColumnType.label,
		},
	];

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
        private formBuilder: FormBuilder,
        private enrollmentAddService: EnrollmentAddService,
        private enrollmentBuyupService: EnrollmentBuyupService,
        private tableService: TableService,
        private dialog: MatDialog,
    ){
        // To allow for multiple selection before executing Load Rate funciton.
        this.debouncer.pipe(debounceTime(1000)).subscribe(() => {
            this.loadRates(true);
        });

        this.enrollmentManagerService.$ReloadCoverageTierGirdByDetailId.subscribe((value: number) => {
            if (value) {
                this.coverageDropDownDetailId = value;
                this.loadRates(true);
            }
        });
    }

    ngOnInit(): void {
        this.renderdColumns = this.tableService.extractTableColumnNames(this.membersColumns);
        this.Members = this.coverageTab.calcedTierOptions;
        let l_FormArray: FormArray = new FormArray([]);
        let l_AddCurrentStatus: boolean;

        let l_ActiveMembers: CoverageDependent[] = new Array<CoverageDependent>();
        let l_NewMembers: CoverageDependent[] = new Array<CoverageDependent>();

        this.Members.forEach(member => {
            if (member.isCurrentlyActive) {
                l_AddCurrentStatus = member.isCurrentlyActive;
                l_FormArray.push(this.buildFormGroup(member));
                l_ActiveMembers.push(member);

                if (member.isSelected)
                    this.selectedMembers.push(member.dependentID);
            }
        });

        this.Members.forEach(member => {
            if (!member.isCurrentlyActive) {
                l_FormArray.push(this.buildFormGroup(member));
                l_NewMembers.push(member);

                if (member.isSelected)
                    this.selectedMembers.push(member.dependentID);
            }
        });

        let l_DataMembers: CoverageDependent[] = new Array<CoverageDependent>();
        if (l_AddCurrentStatus) {
            l_DataMembers = l_ActiveMembers.concat(l_NewMembers);
            this.membersColumns.push({
                columnName: 'Current Status',
                propertyId: 'activeStatus',
                columnType: TableColumnType.label,
                width: '12%',
            });
        } else {
            l_DataMembers = l_NewMembers;
        }

        this.membersData.data = l_DataMembers;

        this.coverageFormGroup.addControl(this.enableFormToggle, new FormControl(true, Validators.requiredTrue));
        this.coverageFormGroup.addControl(
            this.coverageArrayName, 
            l_FormArray,
        );

        this.loadRates(true);
    }

    ngAfterContentChecked(): void {
        if (this.coverageTab.calcedTierOptions.length != this.Members.length) {
            this.coverageTab.calcedTierOptions.forEach((cto: CoverageDependent) => {
                if (!this.Members.some((member: CoverageDependent) => member.dependentID == cto.dependentID)) {
                    this.gridArray.push(this.buildFormGroup(cto));

                    if(cto.isSelected)
                        this.selectedMembers.push(cto.dependentID);
                }
            });

            this.Members = this.coverageTab.calcedTierOptions;

            this.loadRates(false);
        }
    }

    private buildFormGroup(member: CoverageDependent): FormGroup {
        if (member.isRequired)
            member.toggleLabelName = 'Required';
        else if (member.isTermAvailable)
            member.toggleLabelName = 'Term';
        else
            member.toggleLabelName = 'Add';
        

        member.activeStatus = member.isCurrentlyActive ? 'Active' : '';

        return this.formBuilder.group({
            dependentID: [member.dependentID],
            coveredMemberName: [member.coveredMemberName, Validators.required],
            relationship: [member.relationship],
            isRequired: [member.isRequired],
            isAddAvailable: [member.isAddAvailable],
            isTermAvailable: [member.isTermAvailable],
            isSelected: [{ value: member.isSelected, disabled: member.isRequired }, (!member.isTermAvailable && member.isRequired ? Validators.requiredTrue : null)],
            activeStatus: [member.activeStatus],
            [this.toggleLabelName]: [member.toggleLabelName],
        })
    }

    get gridArray(): FormArray {
        return (<FormArray>(this.coverageFormGroup.get(this.coverageArrayName)));
    }

    private loadRates(forceLoad: boolean): void {
        if (!this.coverageFormGroup)
            return;

        if (this.selectedMembers.length > 0)
            this.coverageFormGroup.get('selectedDependentIds').setValue(this.selectedMembers);

        if (forceLoad) {
            switch(this.enrollmentManagerService.benefitWizardControlPanel.wizardType) {
                case BenefitWizardType.Add:
                    this.enrollmentAddService.getCoverageSelectionRates(this.selectedMembers, this.coverageDropDownDetailId).subscribe((respone: CoverageRate) => {
                        this.setTiers(respone);
                    });
                    break;

                case BenefitWizardType.BuyUp:
                    this.enrollmentBuyupService.getCoverageSelectionRates(this.selectedMembers, this.coverageDropDownDetailId).subscribe((respone: CoverageRate) => {
                        this.setTiers(respone);
                    });
                    break;
            }
        }
    }

    private setTiers(coverageRate: CoverageRate): void {
        if (coverageRate) {
            let l_tiers: CoverageRate[] = new Array<CoverageRate>();
            l_tiers.push(coverageRate);
            this.tierData.data = l_tiers;
            this.displayRates = true;
        }
        
        this.coverageFormGroup.get(this.enableFormToggle).setValue(true);
    }

    public selectedMember(member: CoverageDependent){
        if (member.isSelected) {
            this.selectedMembers.push(member.dependentID);
        } else {
            const l_ArrayIndex: number = this.selectedMembers.indexOf(member.dependentID);
            if (l_ArrayIndex !== -1) {
                this.selectedMembers.splice(l_ArrayIndex, 1);
            }
        }

        this.coverageFormGroup.get(this.enableFormToggle).setValue(false);
        this.debouncer.next('');
    }

    public openDependentDialog(): void {
        const l_DependentDialogModel = new DependentDialogModel();
        l_DependentDialogModel.isWizard = true;
        l_DependentDialogModel.wizardType = this.enrollmentManagerService.benefitWizardControlPanel.wizardType;
        const dialogRef = this.dialog.open(DialogDependentComponent, { data: l_DependentDialogModel, panelClass: 'mwp-modal-override-600' });

        dialogRef.afterClosed().subscribe((response: NextPanel) => {
            if (response) {
                this.emitReload.emit();
            }
        });
    }
}